import HTTP from '@/config/axios-config-erp'

const ServiceCertificadosAmbientales = {
  getCertificados (payload) {
    return HTTP.post(`/wscomun/portalinformes/CertificadosMedioAmbiente`, payload).then(response => {
      return response
    }).catch(error => {
      console.log(error.response)
      return { 'status': 500 }
    })
  },
  getDetCertificados (payload) {
    return HTTP.post(`/wscomun/portalinformes/CertificadosMedioAmbienteDet`, payload).then(response => {
      return response
    }).catch(error => {
      console.log(error.response)
      return { 'status': 500 }
    })
  },
  getAgenciasTrabajo (payload) {
    return HTTP.post(`/wscomun/portalinformes/AgenciasTransporte`, payload).then(response => {
      return response
    }).catch(error => {
      console.log(error.response)
      return { 'status': 500 }
    })
  }
}

export default ServiceCertificadosAmbientales



// WEBPACK FOOTER //
// ./src/services/srv-certificados-ambientales.js